import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { getFormattedDate } from 'utils/DataFormatUtils';
import SnackbarUtils from 'utils/SnackbarUtils';
import { Col } from '../../../../../components/Col';
import { CustomCard } from '../../../../../components/CustomCard';
import { CustomTextArea } from '../../../../../components/CustomTextArea';
import { CustomTextField } from '../../../../../components/CustomTextField';
import { GenericProjectCard } from '../../../../../components/GenericProjectCard';
import { Row } from '../../../../../components/Row';
import {
  PROJECT_STATUS_PENDENTE,
  PROJECT_STATUS_RASCUNHO,
} from '../../../../../library/ProjectStatus';
import { getStepSlug } from '../../../../../library/ProjectSteps';
import { projectEdit } from '../../../../../library/Routes';
import { openModal } from '../../../../../store/modules/ModalActions';
import {
  changeProjetoValue,
  loadHistoricoAvaliacoes,
  removerDocumento,
  saveProjeto,
  uploadDocumento,
} from '../../../../../store/modules/ProjetoActions';
import {
  etapaIsUnlocked,
  getProjectFilesByEtapa,
} from '../../../../../utils/ProjetoUtils';
import {
  dateIsValid,
  maskedValueRequiredIsValid,
  periodIsValid,
} from '../../../../../utils/ValidationUtils';

class Etapa7Card2 extends GenericProjectCard {
  constructor(props) {
    super(props);

    this.state = {
      ...(this.state || {}),
      descricaoIndiceFinalChanged: false,
      periodoInicialChanged: false,
      periodoFinalChanged: false,
      sending: false,
    };

    this.setValue = this.setValue.bind(this);
    this.toSubmit = this.toSubmit.bind(this);
    this.saveUploadChanges = this.saveUploadChanges.bind(this);
  }

  UNSAFE_componentWillMount() {
    this.props.loadHistoricoAvaliacoes(this.props.projeto.id, this.stepIndex);
  }

  fieldDisabled() {
    return this.state.saving === true || this.state.loading === true
      ? true
      : false;
  }

  stepIndex = 8;

  validationResults = [false];

  descricaoIndiceFinalIsValid() {
    return this.props.projeto.descricaoIndiceFinal
      ? this.props.projeto.descricaoIndiceFinal.length > 0
      : false;
  }

  periodIsValid = (value1, value2, validationError) => {
    const validation = periodIsValid(value1, value2, validationError);
    if (!validation.status) {
      return validation;
    }
    return {
      status: true,
    };
  };

  inicialPeriodIsValid = () => {
    const requiredErrorMessage =
      this.props.languageValues.validations.projectInicialPeriod.required;
    const validationErrorMessage =
      this.props.languageValues.validations.projectInicialPeriod.validation;
    const required = maskedValueRequiredIsValid(
      this.props.projeto.periodoInicial,
      requiredErrorMessage
    );
    if (!required.status) {
      return required;
    }
    const validation = dateIsValid(
      this.props.projeto.periodoInicial,
      validationErrorMessage
    );
    if (!validation.status) {
      return validation;
    }
    return {
      status: true,
    };
  };

  finalPeriodIsValid = () => {
    const requiredErrorMessage =
      this.props.languageValues.validations.projectFinalPeriod.required;
    const validationErrorMessage =
      this.props.languageValues.validations.projectFinalPeriod.validation;
    const required = maskedValueRequiredIsValid(
      this.props.projeto.periodoFinal,
      requiredErrorMessage
    );
    if (!required.status) {
      return required;
    }
    const validation = this.periodIsValid(
      this.props.projeto.periodoInicial,
      this.props.projeto.periodoFinal,
      validationErrorMessage
    );
    if (!validation.status) {
      return validation;
    }
    return {
      status: true,
    };
  };

  changeSendingStatus(status) {
    this.setState({
      ...this.state,
      sending: status,
    });
  }

  saveUploadChanges() {
    let avaliacao =
      this.props.projeto.avaliacoes.length > this.stepIndex + 1
        ? this.props.projeto.avaliacoes[this.stepIndex]
        : {};
    avaliacao.etapa = this.stepIndex;
    avaliacao.status =
      avaliacao.status === PROJECT_STATUS_RASCUNHO
        ? PROJECT_STATUS_RASCUNHO
        : PROJECT_STATUS_PENDENTE;
    let documentos = [];
    this.props.projeto.documentos.map((file, index) => {
      documentos.push({
        principal: file.principal,
        caminho: file.id,
      });
      return index;
    });
    const data = {
      id: this.props.projeto.id,
      idUsuario: this.props.projeto.idUsuario,
      documentos: documentos,
      avaliacao,
    };
    this.props.saveProjeto(data);
  }

  toSubmit() {
    if (!this.itemsAreValid(this.validationResults)) {
      return;
    }
    this.changeSendingStatus(true);
    let avaliacao =
      this.props.projeto.avaliacoes.length > this.stepIndex + 1
        ? this.props.projeto.avaliacoes[this.stepIndex]
        : {};
    avaliacao.etapa = this.stepIndex;
    avaliacao.status = PROJECT_STATUS_PENDENTE;
    const data = {
      id: this.props.projeto.id || null,
      idUsuario: this.props.projeto.idUsuario,
      descricaoAtividadeIntegradora:
        this.props.projeto.descricaoAtividadeIntegradora,
      descricaoIndiceFinal: this.props.projeto.descricaoIndiceFinal,
      consultaPublica: this.props.projeto.consultaPublica,
      periodoInicial: this.props.projeto.periodoInicial,
      periodoFinal: this.props.projeto.periodoFinal,
      avaliacao,
    };
    this.props.saveProjeto(
      data,
      () => {
        SnackbarUtils.enqueueSnackbar({
          message: this.props.languageValues.successCadastrarEtapa7,
          options: {
            variant: 'success',
          },
        });
        this.changeSendingStatus(false);
        this.props.history.push(
          projectEdit.getURLWithParams(
            this.props.projeto.id,
            getStepSlug(this.stepIndex + 1)
          )
        );
      },
      (error) => {
        SnackbarUtils.enqueueSnackbar({
          message:
            error.response.statusText ||
            this.props.languageValues.erroCadastrarEtapa7,
          options: {
            variant: 'error',
          },
        });
        this.changeSendingStatus(false);
      }
    );
  }

  focusIn = (fieldName) => {
    this.setState({
      ...this.state,
      focusedFieldName: fieldName,
    });
  };

  focusOut = (fieldName) => {
    if (this.state.focusedFieldName === fieldName) {
      this.setState({
        ...this.state,
        focusedFieldName: null,
      });
    }
  };

  render() {
    this.validationResults =
      !etapaIsUnlocked(this.stepIndex, this.props.projeto.avaliacoes) ||
      this.state.sending
        ? [false]
        : [
            this.descricaoIndiceFinalIsValid(),
            this.inicialPeriodIsValid().status,
            this.finalPeriodIsValid().status,
          ];
    return (
      <CustomCard
        stepIndex={this.stepIndex}
        titleHint={this.props.languageValues.hintEtapa7}
        CardHeaderPropTypes={{
          title: this.props.languageValues.etapa7,
        }}
        sending={this.state.sending}
      >
        <form
          className={this.getFormClasses(this.state.sending)}
          onSubmit={(event) => {
            event.preventDefault();
            this.toSubmit(event);
          }}
        >
          <Row className='form-row'>
            <Col cols={[12, 12, 12, 12, 12]}>
              <CustomTextArea
                label={this.props.languageValues.descricaoIndiceFinal}
                name='descricaoIndiceFinal'
                value={this.props.projeto.descricaoIndiceFinal || ''}
                onChange={(event) => {
                  this.setValue(event);
                }}
                error={!this.descricaoIndiceFinalIsValid()}
                counter={true}
                maxSize={2000}
                disabled={
                  this.props.lockedAllFields ||
                  this.state.sending ||
                  !etapaIsUnlocked(
                    this.stepIndex,
                    this.props.projeto.avaliacoes
                  )
                }
              />
            </Col>
          </Row>
          <Row>
            <Col cols={[6, 6, 6, 6, 6]}>
              <CustomTextField
                label={this.props.languageValues.periodoInicial}
                name='periodoInicial'
                value={this.props.projeto.periodoInicial || ''}
                onChange={(evt) => {
                  const { value } = evt.target;
                  evt.target.value = getFormattedDate(value);
                  this.setValue(evt);
                }}
                helperText={
                  !this.inicialPeriodIsValid().status
                    ? this.inicialPeriodIsValid().error
                    : ''
                }
                error={!this.inicialPeriodIsValid().status}
                disabled={
                  this.props.lockedAllFields ||
                  this.state.sending ||
                  this.fieldDisabled()
                }
              />
            </Col>
            <Col cols={[6, 6, 6, 6, 6]}>
              <CustomTextField
                label={this.props.languageValues.periodoFinal}
                name='periodoFinal'
                value={this.props.projeto.periodoFinal || ''}
                onChange={(evt) => {
                  const { value } = evt.target;
                  evt.target.value = getFormattedDate(value);
                  this.setValue(evt);
                }}
                helperText={
                  this.inicialPeriodIsValid().status &&
                  !this.finalPeriodIsValid().status
                    ? this.finalPeriodIsValid().error
                    : ''
                }
                error={
                  this.inicialPeriodIsValid().status &&
                  !this.finalPeriodIsValid().status
                }
                disabled={
                  this.props.lockedAllFields ||
                  this.state.sending ||
                  this.fieldDisabled() ||
                  !this.inicialPeriodIsValid().status
                }
              />
            </Col>
          </Row>
          <Row className='form-row'>
            <Col cols={[12, 12, 12, 12, 12]}>
              {this.getUploaderButton(
                this.props.languageValues.uploadLabelButton,
                getProjectFilesByEtapa(
                  this.props.projeto.documentos,
                  this.stepIndex,
                  this.props.projeto.id
                ).length || 0,
                this.props.lockedAllFields ||
                  this.state.sending ||
                  !etapaIsUnlocked(
                    this.stepIndex,
                    this.props.projeto.avaliacoes
                  ),
                {
                  titleHint: this.props.languageValues.direitoImagemHint,
                  toUpload: this.props.uploadDocumento,
                  toRemove: (caminho) =>
                    new Promise((res, rej) => {
                      this.props.removerDocumento(caminho, res, rej);
                    }),
                  cooperativa: this.props.projeto.codigoCooperativa,
                  etapa: this.stepIndex,
                  idProjeto: this.props.projeto.id,
                  fileList: getProjectFilesByEtapa(
                    this.props.projeto.documentos,
                    this.stepIndex,
                    this.props.projeto.id
                  ),
                  onChanged: (list) => {
                    this.mergeFiles(
                      this.props.projeto.documentos,
                      list,
                      this.stepIndex,
                      this.props.projeto.id
                    );
                    this.saveUploadChanges();
                  },
                  getRefreshedList: () => {
                    return getProjectFilesByEtapa(
                      this.props.projeto.documentos,
                      this.stepIndex,
                      this.props.projeto.id
                    );
                  },
                },
                this.props.openModal
              )}
            </Col>
          </Row>
          {this.getActionsRow([
            [
              null,
              this.getHistoryButton(
                this.props.languageValues.reviewButton,
                this.props.languageValues.etapa7,
                this.props.projeto.historico &&
                  this.props.projeto.historico[this.stepIndex]
                  ? this.props.projeto.historico[this.stepIndex]
                  : [],
                this.stepIndex,
                this.props.openModal
              ),
            ],
            [
              this.getPreviousButton(!this.state.sending),
              this.getFinalyButton(
                this.props.lockedAllFields ||
                  !this.itemsAreValid(this.validationResults),
                this.toSubmit
              ),
            ],
          ])}
        </form>
      </CustomCard>
    );
  }
}

const mapStateToProps = (state) => ({
  languageValues: state.languages.languageValues,
  projeto: state.projeto.projetoEditing,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      changeProjetoValue,
      saveProjeto,
      loadHistoricoAvaliacoes,
      openModal,
      uploadDocumento,
      removerDocumento,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Etapa7Card2));
